module.exports = __webpack_public_path__ + "static/img/Yee.5105d4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Yee.jpg
// module id = Ddbl
// module chunks = 1